// @ts-nocheck
import useStructuredData from "@toolkit/Framework/Common/Hooks/useStructuredData";
import isAbsoluteUrl from "@toolkit/Framework/Common/Utilities/isAbsoluteUrl";
import { useSettingsCollection, useWebsite } from "@toolkit/Framework/Store/Context/ContextHooks";
import { useHomePageUrl } from "@toolkit/Framework/Store/Links/LinksHooks";
import { FC, useEffect, useState } from "react";
import { Organization } from "schema-dts";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/search/docs/appearance/structured-data/logo
/* ---------------------------------------------------------------------------------------------------- */

export interface OrganizationStructuredDataProps {}

const OrganizationStructuredData: FC<OrganizationStructuredDataProps> = () => {
    const [structuredData, setStructuredData] = useState<Exclude<Organization, string>>();
    const website = useWebsite();
    const homePageUrl = useHomePageUrl();

    const {
        extensionWebsiteSettings: {
            companyEmail,
            companyPhoneNumber,
            enableStructuredData,
            enableStructuredDataOrganization,
            structuredDataOrganizationLogo,
        },
    } = useSettingsCollection();

    useEffect(() => {
        if (!enableStructuredData || !enableStructuredDataOrganization || !website || typeof window === "undefined") {
            return;
        }

        const logoPath = structuredDataOrganizationLogo || website.properties.logoImagePath;

        setStructuredData({
            "@type": "Organization",
            name: website.name,
            url: `${window.location.origin}${homePageUrl}`,
            description: website.description,
            telephone: companyPhoneNumber,
            email: companyEmail,
            address: {
                "@type": "PostalAddress",
                addressRegion: website.properties.state,
                postalCode: website.properties.postalCode,
                addressCountry: website.properties.country,
                addressLocality: website.properties.city,
                streetAddress: `${website.properties.address1}${
                    website.properties.address2 ? `, ${website.properties.address2}` : ""
                }`,
            },
            logo: isAbsoluteUrl(logoPath)
                ? logoPath
                : `${window.location.origin}${logoPath.startsWith("/") ? logoPath : `/${logoPath}`}`,
        });
    }, [website]);

    useStructuredData(structuredData);

    return null;
};

export default OrganizationStructuredData;
